import { Chat_content } from "../../../Components/MessageApp/MessagesInterfaces";

import Otter from "../ActivistAssets/Avatars/Otter Profile Pic.jpg";
import Salamander from "../ActivistAssets/Avatars/Salamander Profile Pic.jpg";
import Woodpecker from "../ActivistAssets/Avatars/Woodpecker Profile Pic.jpg";
import spam from "../ActivistAssets/Avatars/Spam Texts Profile pic.jpg";

export const influencerMessageContent: Chat_content[] = [
  {
    icon: Otter,
    type: "individual",
    name: "Otter",
    messages: [
      {
        content: {
          type: "text",
          content: "how's the blood mixture going? ",
        },
        timestamp: "2024-04-05T12:44:00Z",
        from: "Otter",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "it's still not binding 😔",
        },
        timestamp: "2024-04-05T12:53:00Z",
        from: "Dolphin",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "You probably need corn syrup love",
        },
        timestamp: "2024-04-05T12:57:00Z",
        from: "Otter",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "I knowwww you said that yesterday",
        },
        timestamp: "2024-04-05T12:59:00Z",
        from: "Dolphin",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "But it's all industrial and mass produced and I don't feel good about that",
        },
        timestamp: "2024-04-05T13:00:00Z",
        from: "Dolphin",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Look, I know it's bad but it's just a means to an end, we have good intentions",
        },
        timestamp: "2024-04-05T13:01:00Z",
        from: "Otter",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "if you want I'll buy it so you don't need to have anything to do with it",
        },
        timestamp: "2024-04-05T13:02:00Z",
        from: "Otter",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "are you in?",
        },
        timestamp: "2024-04-05T13:03:00Z",
        from: "Otter",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "I'm out all day with Salamander",
        },
        timestamp: "2024-04-05T13:05:00Z",
        from: "Dolphin",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "I'll come and add it in myself, is the back door open?",
        },
        timestamp: "2024-04-05T13:06:00Z",
        from: "Otter",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "are you sure? I know it's weird I just can't do it myself",
        },
        timestamp: "2024-04-05T13:06:00Z",
        from: "Dolphin",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "of course, don't worry consider it done",
        },
        timestamp: "2024-04-05T13:10:00Z",
        from: "Otter",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "This is your last chance to hand over the money Nick. You know you don't deserve it. You took the decision to abandon our family 15 years ago, if you take the money now you're stealing from us",
        },
        timestamp: "2024-04-07T18:47:00Z",
        from: "Otter",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "I've told you already I can't do that. I'm not taking the money for myself it's all going into funding environmental charities and groups. You never really cared about A.R. did you? How could you if you're so against what I'm doing. I've spent months thinking about this and I'm not changing my mind now.",
        },
        timestamp: "2024-04-07T18:55:00Z",
        from: "Dolphin",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Of course I support A.R I'm risking arrest at the protest tomorrow. But that's my money and it's my right to choose how to spend it",
        },
        timestamp: "2024-04-07T18:57:00Z",
        from: "Otter",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "please can we just move on and focus on the protest tomorrow - we've discussed this enough already",
        },
        timestamp: "2024-04-07T19:03:00Z",
        from: "Dolphin",
        status: "Read",
      },
    ],
    read: true,
  },
  {
    icon: Salamander,
    type: "individual",
    name: "Salamander",
    messages: [
      {
        content: {
          type: "text",
          content:
            "bro, I think I left my green sweater at the last AR meeting have you or Hannah seen it?",
        },
        timestamp: "2023-03-26T11:41:00Z",
        from: "Salamander",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "yeah we have it at ours man",
        },
        timestamp: "2023-03-26T11:57:00Z",
        from: "Dolphin",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "awesome can I come pick it up this eve?",
        },
        timestamp: "2023-03-26T11:59:00Z",
        from: "Salamander",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "yeah of course",
        },
        timestamp: "2023-03-26T12:06:00Z",
        from: "Dolphin",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "mi casa es su casa",
        },
        timestamp: "2023-03-26T12:06:00Z",
        from: "Dolphin",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "I’ll be there in 5 mins",
        },
        timestamp: "2023-03-26T18:39:00Z",
        from: "Salamander",
        status: "Read",
      },
    ],
    read: true,
  },
  {
    icon: Woodpecker,
    type: "individual",
    name: "Woodpecker",
    messages: [
      {
        content: {
          type: "text",
          content:
            "hey han, I know it’s been ages since I’ve seen your parents but I honestly just can’t make it this Saturday I’m sorry. I have so much still to do for my pottery class on Sunday", // Placeholder for message content
        },
        timestamp: "2023-03-21T16:19:00Z",
        from: "Dolphin",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "hey darling, can’t you leave the pottery stuff for next week? You haven’t come with me to my parents house the last two times…", // Placeholder for message content
        },
        timestamp: "2023-03-21T16:22:00Z",
        from: "Woodpecker",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "It’s because we’re firing everything in the kiln this Sunday so it all really needs to be finished", // Placeholder for message content
        },
        timestamp: "2023-03-21T16:24:00Z",
        from: "Dolphin",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "okay babe that’s okay. It has been a long time and I think my parents are starting to feel like you’re avoiding them but I know the pottery class is important to you", // Placeholder for message content
        },
        timestamp: "2023-03-21T16:26:00Z",
        from: "Woodpecker",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "can you please make sure you’re available next time I go to visit them? You’d be doing me a favor too, I much prefer going with you than alone", // Placeholder for message content
        },
        timestamp: "2023-03-21T16:27:00Z",
        from: "Woodpecker",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "yes I promise", // Placeholder for message content
        },
        timestamp: "2023-03-21T16:28:00Z",
        from: "Dolphin",
        status: "Read",
      },
    ],
    read: true,
  },
  {
    icon: spam,
    type: "individual",
    name: "EcoThreads",
    messages: [
      {
        content: {
          type: "text",
          content:
            "Sale is up to 50% off! You're in the exclusive access circle to access before everyone else, dive in!",
        },
        timestamp: "2024-04-03T12:01:00Z",
        from: "EcoThreads",
        status: "Read",
      },
    ],
    read: true,
  },
  {
    icon: spam,
    type: "individual",
    name: "Deliveree",
    messages: [
      {
        content: {
          type: "text",
          content:
            "Your Deliveree order is in the kitchen and will be with you soon! ",
        },
        timestamp: "2024-04-01T19:12:00Z",
        from: "Deliveree",
        status: "Read",
      },
    ],
    read: true,
  },
];
